import { TableWrapper, type TableWrapperProps } from "../../../common/components/Table.tsx";
import * as commonColumns from "../../../common/columns.tsx";
import type {
  PaginatedturbineResultsSideloadList,
  Turbine,
} from "../../generated-axios-client/index.ts";
import type { AnyObject } from "antd/es/_util/type";
import type { ClientViewRenderProps } from "./ClientViewRender.tsx";
import { Card } from "../../../common/components/Card.tsx";
import {
  turbineActions,
  type SideloadedTurbineInfo,
} from "../../../features/turbine/turbineSlice.ts";
import { EyeOutlined, UnorderedListOutlined } from "@ant-design/icons";
import { actions as routerActions } from "redux-router5";
import { routeNames } from "../../common/routes.ts";

type rowDataType = {
  turbines: PaginatedturbineResultsSideloadList;
  turbineSideload: SideloadedTurbineInfo | null;
};

const getColumns: TableWrapperProps<
  PaginatedturbineResultsSideloadList,
  AnyObject
>["getColumns"] = (intl) => [
  commonColumns.simpleColumn("serial_number", "turbine_table_column_serial_number", intl),
  commonColumns.simpleColumn("park_number", "turbine_table_column_park_number", intl),
  commonColumns.simpleColumn("latitude", "turbine_table_column_latitude", intl),
  commonColumns.simpleColumn("longitude", "turbine_table_column_longitude", intl),
  commonColumns.simpleColumn("location", "turbine_table_column_location", intl),
  commonColumns.simpleColumn("created_at", "turbine_table_column_created_at", intl),
  commonColumns.simpleColumn("updated_at", "turbine_table_column_updated_at", intl),
  commonColumns.simpleColumn("actions", "table_column_actions", intl),
];

const getTableRows: TableWrapperProps<rowDataType, AnyObject>["getRows"] = (
  intl,
  dispatch,
  data
) => {
  const { turbines, turbineSideload } = data;

  return Object.values(turbines.results.turbines).map((turbine: Turbine) => {
    const onViewTurbine = () => {
      if (turbine.id) {
        dispatch(routerActions.navigateTo(routeNames.TURBINE_VIEW, { id: turbine.id }));
      }
    };

    const onShowWorkOrders = () => {
      if (turbine.id) {
        dispatch(turbineActions.getTurbineWorkOrders(turbine.id));
      }
    };

    return {
      key: turbine.id,
      serial_number: turbine.serial_number,
      park_number: turbine.park_number ?? "—",
      latitude: turbine.latitude,
      longitude: turbine.longitude,
      location: turbineSideload?.location[turbine.location].name,
      created_at: turbine.created_at ? commonColumns.dateValue(turbine.created_at, intl) : "—",
      updated_at: turbine.updated_at ? commonColumns.dateValue(turbine.updated_at, intl) : "—",
      actions: commonColumns.actionsValue(
        undefined,
        undefined,
        turbine,
        undefined,
        undefined,
        undefined,
        undefined,
        [
          { key: "view", icon: <EyeOutlined />, onClick: onViewTurbine, tooltip: "View Turbine" },
          { key: "work-orders", icon: <UnorderedListOutlined />, onClick: onShowWorkOrders, tooltip: "Show Work Orders" },
        ]
      ),
    };
  });
};

export const TurbinesInfo = (props: ClientViewRenderProps) => {
  const { intl, clientData, modalApi } = props;
  const { turbines, turbineSideload } = clientData;

  const rowData: rowDataType = { turbines, turbineSideload };

  return (
    <Card title={intl.formatMessage({ id: "turbines" })}>
      <TableWrapper
        intl={intl}
        getColumns={getColumns}
        getRows={getTableRows}
        data={rowData}
        modalApi={modalApi}
        size="small"
      />
    </Card>
  );
};
